export default "__VITE_ASSET__7xmtWcHa__"